import UI from "./base/UI";
import {scrollTo, wrapInnerScroll} from "../functions/simple.ui";

import { isA11yCheckVersion } from "../functions/a11y.ui";
/**
 * Expand
 */
/**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_expand.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_expand.html)
*/
class Expand extends UI {
    defaults = {
        scroll: false,
        textArr: []
    };

    constructor(el, options) {
        super('expand', el);

        this.init(el, options);
    }

    init(el, options) {
        this.defaults = {...this.defaults, ...this.parseOptions(options)};

        if(this.defaults.line){
            this.$el.find('ul > li').toArray().forEach((li, index) => {
                if(index >= this.defaults.line){ // 240529  3 -> this.defaults.line 수정
                    $(li).addClass('ui-expand-cont');
                }
            })
        }
        if (this.defaults.expandText != undefined) {  // FETASK-1481
            for (var i = 0; i < this.defaults.expandText.split(',').length; i++) {
                this.defaults.textArr.push(this.defaults.expandText.split(',')[i])
            }
        }
        this.update();
        this.render();
        /*! s: FETASK-a11y page Expand 접근성 v.1.0.0 */
        this.isA11yExpandAccess(this.$el);
        /*! e: FETASK-a11y page Expand 접근성 v.1.0.0 */
    }

    update() {
        if(this.$el.hasClass('keyword-select-chips')){ 
            const minHeight = parseInt(window.getComputedStyle(this.$el[0]).minHeight);

            if(this.$el[0].clientHeight > minHeight){
                this.$el.find('.ui-expand-btn').show();
                wrapInnerScroll(this.$el, '.select-chips');
            }else{
                if(this.$el.find('.inner-scroll').length) this.initScrollLeft();
                if(this.$el.hasClass('type0')) return false;
                this.$el.addClass('type0');
                this.update();
            }
        }
        this.expandWidthTab() // FETASK-1678 
        
    }

    render() {
        this.detachEvents();
        this.attachEvents();

    }

    attachEvents() {
        this.$el.on(`click${this.eventId}`, '.ui-expand-btn', (e) => {
            e.preventDefault();
            const $this = $(e.currentTarget);
            let status = null;
            if ($this.parents('.ui-expand').hasClass('open')) {
                this.close($this);
                $this.attr('aria-expanded', 'false');
                this.btnTextSet('close') // FETASK-1481
                status = false;
            } else {
                this.open($this);
                $this.attr('aria-expanded', 'true');
                this.btnTextSet('open') //FETASK-1481
                status = true;
            }
            if (this.$el.closest('.ui-popup').length > 0) { //FETASK-1653 : 바텀 더보기로 유동적으로 변할때 
                this.$el.closest('.ui-popup').data('ui').popupContHeightCheck()
            }

            if (this.toggleCallback && $.isFunction(this.toggleCallback)) { // 240930 CHPFMTASK-870 toggle callback 추가
                this.toggleCallback(status);
            }

            /*! s: FETASK-a11y page Expand 접근성 v.1.0.0 */
            this.isA11yExpandAccess(this.$el);
            /*! e: FETASK-a11y page Expand 접근성 v.1.0.0 */
        });
    }
    /**
     * @param  target   $('.ui-expand').find('.ui-expand-btn')
     * @example 
     * $('.ui-expand').data('ui').open($('.ui-expand').find('.ui-expand-btn'));
     */
    open(target) {
        target.parents('.ui-expand').addClass('open');
        this.scrollToExpandEl();
    }
    /**
     * @param  target   $('.ui-expand').find('.ui-expand-btn')
     * @example 
     * $('.ui-expand').data('ui').close($('.ui-expand').find('.ui-expand-btn'));
     */
    close(target) {
        target.parents('.ui-expand').removeClass('open');
         
    }

    initScrollLeft(){
        this.$el.find('.inner-scroll')[0].scrollLeft > 0 && (this.$el.find('.inner-scroll')[0].scrollLeft = 0);
    }
    /**
     * open시 스크롤 이동  콜백함수 안에 사용
     * @example 
     * <div class="ui-expand" data-scroll="true"></div>
     * $('.ui-expand').data('ui').callback(function(){$('.ui-expand').data('ui').scrollToExpandEl()});
     */
    scrollToExpandEl() {
        if (this.$el.attr('data-scroll') == 'true') {
            scrollTo(this.$el);
        }
    }
    expandWidthTab(){// FETASK-1678 
        if(this.$el.find('.ui-tab-nav').length > 0){
            let itemWidth = 0;
            let itemLast = this.$el.find('.tab-item:last-child');
            let addPading = this.$el.find('.tab-round-group').length>0  ? this.$el.css('padding-left').replace('px','') : 0;
            this.$el.find('.tab-item').each(function(){
                itemWidth += $(this).outerWidth()
            })
            itemLast.removeAttr('style')
            if(this.$el.outerWidth() - addPading < itemWidth){
                this.$el.find('.ui-expand-btn').show();
            } else {
                this.$el.find('.ui-expand-btn').hide();
                itemLast.css('padding-right', 0)
            }
        }
    }

    btnTextSet(status) { // FETASK-1481
        if (this.defaults.expandText != undefined) {
            if (status == 'open') {
                this.$el.find('.ui-expand-text').text(this.defaults.textArr[1].trim())
            } else {
                this.$el.find('.ui-expand-text').text(this.defaults.textArr[0].trim())
            }
        }
    }
    /**
     * @param {function} callback   toggle event 이후 콜백  상태값  리턴 (true/false)
     * @example 
     * $('.ui-expand').data('ui').callback(function(status){});   //status == true/false
     */
    callback(callback) { // 240930 CHPFMTASK-870 toggle callback 추가
        this.toggleCallback = callback;
    }

    detachEvents() {
        this.$el.off(this.eventId);
    }

    destroy() {
        this.detachEvents();
    }

    isA11yExpandAccess(element){
        const isCheckExpand = element.parent().parent().hasClass('component-tab');
        const isA11yCheck = isA11yCheckVersion();

        if(isA11yCheck){
            if(!isCheckExpand){
                const isToggle = element[0].classList.contains('open');
                element.find('.ui-expand-cont, .ui-expand-btn').attr('aria-expanded', isToggle);
                
                if(isToggle){
                    element[0]?.children[0]?.setAttribute('aria-hidden','false');
                    if(element[0]?.children[0]?.focus()){
                        //일반 접고 펼침 토글 형태 유형
                        element[0]?.children[0]?.focus();
                    }else{
                        //더보기 펼쳐지고 더보기 버튼 사라지는 유형
                        this.$el.find('.ui-expand-btn').focus();
                        setTimeout(() => {
                            this.$el.find('.ui-expand-cont .area-term').eq(0).attr({'tabindex':'0'}).focus();
                        },1000);
                    }
                }else{
                    element[0]?.children[0]?.removeAttribute('aria-hidden');
                }
    
                /*! s: FETASK-a11y page select-chips v.1.0.0 */
                const selectChips = element[0].querySelectorAll('.select-chips');
    
                selectChips?.forEach((item) => {
                    const labelEle = item.querySelector('label');
                    const inputEle = item.querySelector('input');
                    const isCheckNew = item.classList.contains('new');
    
                    item.removeAttribute('aria-expanded');
                    labelEle && labelEle.setAttribute('aria-hidden','true');
                    inputEle && inputEle.setAttribute('aria-label', isCheckNew ? `${labelEle?.innerText},신규` : `${labelEle?.innerText}`);
                });
                /*! e: FETASK-a11y page select-chips v.1.0.0 */
            }
        }
    }
}

export default Expand;
